import { getLiteral } from 'utils/getLiteral';

export default () => ({
    useFiltersDrawer: false,
    quickFilters: ['productCategories', 'fcreado', 'fmodificado', 'syncStatusId'],
    defaultFilters: ['productCategories', 'fcreado', 'fmodificado', 'syncStatusId'],
    filtersAddButtonSchema: [
        {
            label: getLiteral('label_standard_filters_section_title'),
            options: ['productCategories', 'fcreado', 'fmodificado', 'syncStatusId', 'extid'],
        },
    ],
});
